<template>
  <div class="draws">
    <div class="date" @click="show = true">
      {{ activeDate }}<van-icon name="arrow-down" style="margin-left: 2px;" />
    </div>
    <div class="title">
      <img src="https://images.snsports.cn/FnDne4qYPfJk273k70ddVYucHIRP" />
      <img src="https://images.snsports.cn/Fov8ZU4QbBc286FVmb5TaBUe-Ddr" style="width: 74px;" />
    </div>
    <div class="site-list">
      <div class="scroll-container">
        <div class="site-box">
          <div class="site-item" v-for="item in siteList" :key="item.id">
            <div class="site-title">{{ item.name }}</div>
          </div>
        </div>
        <div class="game-box">
          <div class="site-item" v-for="item in siteList" :key="item.id">
            <div class="game-item" v-for="(game, index) in item.gameList" :key="game.id">
              <div class="top" @click="goManage(game, item.name)">
                <div class="seq">
                  <span>第</span><span>{{ index + 1 }}</span><span>场</span>
                  <img
                    class="icon"
                    v-if="isUnionMatchManager"
                    src="https://images.snsports.cn/FvrdVs1sIReV5VKeGMwNfPB5NVGd"
                  />
                </div>
                <div class="info">
                  <div class="date" :style="getColor(game.matchId, 'date')">
                    <span v-if="game.beginDateMode === 0">{{ getFormatDate(game.beginDate, '{h}:{i}') || '开赛时间待定' }}</span>
                    <span v-else-if="game.beginDateMode === 1">接上一场</span>
                    <span v-else-if="game.beginDateMode === 2">不早于{{ getFormatDate(game.beginDate, '{h}:{i}') }}</span>
                  </div>
                  <div class="group" :style="getColor(game.matchId, 'date')">
                    <div>{{ game.group }}</div>
                    <div>
                      <span v-if="game.isGroupGame === 1">小组赛</span>
                      <span v-else>淘汰赛</span>
                      <span v-if="game.round >= 0">第{{ game.round }}轮</span>
                      <span v-else>其他轮次</span>
                    </div>
                  </div>
                </div>
                <img class="img" :src="mp4" v-if="getGameStatus(game) === 'mp4'" />
                <img class="img" :src="live" v-else-if="getGameStatus(game) === 'live'" />
              </div>
              <div
                class="box"
                @click="goDetail(game)"
                :class="{ complete: game.gameStage === 1 }"
                :style="{ background: game.gameStage === 1 ? getColor(game.matchId, 'group').background : '' }"
              >
                <div class="team">
                  <img
                    :src="game.homeTeamBadge"
                    class="team-badge"
                    v-if="game.homeTeamBadge && !game.homeTeamBadge.includes('Fv8xygIbCVZLczeW3yIoxmd8terA') && !game.homeTeamBadge.includes('FsMSWtEkVb-QBSl7WOQ_SHADOaO0')"
                  />
                  <div
                    v-if="game.homeTeamName"
                    style="display: flex;flex-direction: column;align-items: center;justify-content: center;"
                  >
                    <div class="team-name">
                      {{ game.homeTeamName }}
                      <img v-if="game.homeScore > game.awayScore" :src="completeImg" class="complete-img" />
                    </div>
                    <div class="name-remark" v-if="game.homeNameRemark">{{ game.homeNameRemark }}</div>
                    <div class="delegation" v-if="game.homeDelegation">{{ game.homeDelegation }}</div>
                  </div>
                  <div v-else style="color: #8D8D8D;">暂未确认</div>
                </div>
                <div class="vs">
                  <div v-if="game.homeScore > -1 && game.awayScore > -1">
                    <div v-if="game.unitType === 0">
                      <div>{{ game.homeScore }}</div>
                      <div style="margin-top: 4px;">{{ game.awayScore }}</div>
                    </div>
                    <div v-else>
                      <div class="sub-score">
                        <div
                          v-for="(score, si) in formatSubScores(game.subScore)"
                          :key="si"
                          :class="{ win: score.homeScore > score.awayScore }"
                        >
                          {{ score.homeScore }}
                        </div>
                      </div>
                      <div class="sub-score">
                        <div
                          v-for="(score, si) in formatSubScores(game.subScore)"
                          :key="si"
                          :class="{ win: score.awayScore > score.homeScore }"
                        >
                          {{ score.awayScore }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <span v-else-if="game.roundDescription">{{ game.roundDescription }}</span>
                </div>
                <div class="team">
                  <img
                    :src="game.awayTeamBadge"
                    class="team-badge"
                    v-if="game.awayTeamBadge && !game.homeTeamBadge.includes('Fv8xygIbCVZLczeW3yIoxmd8terA') && !game.homeTeamBadge.includes('FsMSWtEkVb-QBSl7WOQ_SHADOaO0')"
                  />
                  <div
                    v-if="game.awayTeamName"
                    style="display: flex;flex-direction: column;align-items: center;justify-content: center;"
                  >
                    <div class="team-name">
                      {{ game.awayTeamName }}
                      <img v-if="game.awayScore > game.homeScore" :src="completeImg" class="complete-img" />
                    </div>
                    <div class="name-remark" v-if="game.awayNameRemark">{{ game.awayNameRemark }}</div>
                    <div class="delegation" v-if="game.awayDelegation">{{ game.awayDelegation }}</div>
                  </div>
                  <div v-else style="color: #8D8D8D;">暂未确认</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom">
      <van-picker
        title="比赛日期"
        show-toolbar
        :columns="dates"
        :defaultIndex="defaultIndex"
        value-key="beginDate"
        @cancel="show = false"
        @confirm="confirm"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Popup, Picker } from 'vant'
Vue.use(Popup).use(Picker)

import { getUnionMatchFieldGameDateList, getUnionMatchFieldGameList } from '@/api/match-team-game'
import { getBMMatchList2 } from '@/api/match'
import ColorList from '@/utils/colorList'
import { DateUtil } from '@/utils'

export default {
  name: 'UnionMatchDraws',
  data() {
    return {
      unionMatchId: '',
      dates: [],
      activeDate: '',
      show: false,
      siteList: [],
      groupList: [],
      ColorList,
      defaultIndex: 0,
      mp4: 'https://images.snsports.cn/FuLkSv4qR0RynUd9u0wOq-9oA-dO', // 兜底：不依赖本地资源
      live: 'https://images.snsports.cn/FpZC7H9t4rYk2Lr5xJZ1_Rn8bJm1',
      completeImg: require('@/assets/images/success-icon.png'),
      isUnionMatchManager: false,
      gameBoxScrollTop: 0,
      siteListScrollLeft: 0
    }
  },
  mounted() {
    this.unionMatchId = this.$route.query.unionMatchId
    if (this.unionMatchId) {
      this.getUnionMatchFieldGameDateList()
      this.getBMMatchList2()
    }
    this.$nextTick(() => {
      const gameBox = this.$el.querySelector('.game-box')
      if (gameBox) gameBox.scrollTop = 0
      const siteList = this.$el.querySelector('.site-list')
      if (siteList) siteList.scrollLeft = 0
    })
  },
  activated() {
    this.$nextTick(() => {
      const gameBox = this.$el.querySelector('.game-box')
      if (gameBox) gameBox.scrollTop = this.gameBoxScrollTop || 0
      const siteList = this.$el.querySelector('.site-list')
      if (siteList) siteList.scrollLeft = this.siteListScrollLeft || 0
    })
  },
  methods: {
    goManage(game) {
      if (!this.isUnionMatchManager) return
      this.$router.push({ path: `/match-manage/scoring-console/${this.unionMatchId}`, query: { gameId: game.id } })
    },
    getGameStatus(game) {
      if (game.livePublic === 0) return ''
      if (game.liveStatus === 1) return 'live'
      if (game.liveStatus === 2) return 'mp4'
      return ''
    },
    goDetail(item) {
      if ((item.awayScore > -1 && item.homeScore > -1) || this.getGameStatus(item) !== '') {
        this.$router.push(`/game/${item.id}/data`)
      }
    },
    getFormatDate(date, type = '{y}.{m}.{d} {h}:{i}') {
      return DateUtil.parseDateTime(date, type)
    },
    getColor(id, type) {
      const group = this.groupList.find((item) => item.id === id)
      if (!group) return {}
      if (type === 'date') {
        return { background: group.frontView }
      } else {
        return { background: group.backgroundColor }
      }
    },
    getUnionMatchFieldGameDateList() {
      getUnionMatchFieldGameDateList({ unionMatchId: this.unionMatchId }).then((res) => {
        const { data } = res
        this.dates = data.list
        this.activeDate = this.getNearestDate(data.list)
        this.defaultIndex = this.dates.findIndex((item) => item.beginDate === this.activeDate)
        this.getUnionMatchFieldGameList()
      })
    },
    getBMMatchList2() {
      getBMMatchList2({ unionMatchId: this.unionMatchId }).then((res) => {
        const { data } = res
        this.groupList = data.list.map((item, i) => {
          const color = this.ColorList[i % 8]
          item.frontView = color.frontView
          item.backgroundColor = color.backgroundColor
          return item
        })
      })
    },
    getNearestDate(dateList) {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
      const todayDate = dateList.find((item) => {
        const itemDate = new Date(item.beginDate)
        const itemDateOnly = new Date(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate()).getTime()
        return itemDateOnly === today
      })
      if (todayDate) return todayDate.beginDate

      const nowTime = now.getTime()
      const dateMap = dateList.map((item) => {
        const timestamp = new Date(item.beginDate).getTime()
        return { ...item, timestamp, diff: timestamp - nowTime }
      })
      const futureDates = dateMap.filter((d) => d.diff > 0)
      const pastDates = dateMap.filter((d) => d.diff <= 0)

      if (futureDates.length > 0) {
        return futureDates.reduce((a, b) => (a.diff < b.diff ? a : b)).beginDate
      }
      if (pastDates.length > 0) {
        return pastDates.reduce((a, b) => (Math.abs(a.diff) < Math.abs(b.diff) ? a : b)).beginDate
      }
      return null
    },
    getUnionMatchFieldGameList() {
      getUnionMatchFieldGameList({ unionMatchId: this.unionMatchId, date: this.activeDate }).then((res) => {
        if (res) {
          const { data } = res
          this.isUnionMatchManager = data.isUnionMatchManager
          this.siteList = data.list
        }
      })
    },
    confirm(e) {
      this.activeDate = e.beginDate
      this.getUnionMatchFieldGameList()
      this.show = false
    },
    formatSubScores(subScore) {
      if (!subScore) return []
      return subScore
        .split(',')
        .map((score) => {
          const [homeScore, awayScore] = score.split(':').map(Number)
          if (homeScore === -1 || awayScore === -1) return null
          return { homeScore, awayScore }
        })
        .filter(Boolean)
    }
  },
  beforeRouteLeave(to, from, next) {
    const gameBox = this.$el.querySelector('.game-box')
    if (gameBox) this.gameBoxScrollTop = gameBox.scrollTop
    const siteList = this.$el.querySelector('.site-list')
    if (siteList) this.siteListScrollLeft = siteList.scrollLeft
    next()
  }
}
</script>

<style scoped lang="scss">
.draws {
  padding: 8px;
  color: #4D4D4D;
  min-height: 100vh;

  .date {
    height: 40px;
    border-radius: 3px;
    background-color: #f6f6f6;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-weight: 500;
    color: #3F3F3F;
  }

  .title {
    margin: 6px 0;

    img {
      width: 62px;
      height: 22px;
      margin-right: 28px;
    }
  }

  .site-list {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;

    > div.scroll-container {
      display: inline-block;
      min-width: 100%;

      .site-box {
        display: flex;

        .site-item {
          margin-right: 12px;

          .site-title {
            text-align: center;
            width: 173px;
            height: 49px;
            line-height: 49px;
            background: #D7F4F1;
            border-radius: 5px;
            font-weight: 500;
            font-size: 18px;
            color: #3F3F3F;
          }
        }
      }

      .game-box {
        height: calc(100vh - 140px - 12px);
        display: flex;
        overflow-y: auto;
        white-space: normal;

        .site-item {
          width: 173px;
          margin-right: 12px;
          flex-shrink: 0;

          .game-item {
            width: 173px;
            margin-top: 10px;
            color: #4D4D4D;
            border-radius: 5px;
            overflow: hidden;

            .top {
              position: relative;
              display: flex;

              .img {
                position: absolute;
                top: 0px;
                right: 0px;
                height: 20px;
                width: 20px;
              }

              .seq {
                color: #FFFFFF;
                width: 31px;
                height: 91px;
                background: #333333;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                font-size: 16px;
                .icon {
                  width: 16px;
                  height: 16px;
                }
              }

              .info {
                flex: 1;

                .date {
                  font-size: 18px;
                  font-weight: 500;
                  height: 36px;
                  line-height: 36px;
                }

                .group {
                  div {
                    font-size: 17px;
                    font-weight: 500;
                  }
                  text-align: center;
                  height: 55px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                }
              }
            }

            .box {
              &.complete {
                .team-name {
                  color: #fff !important;
                }
                .delegation {
                  color: #fff !important;
                  background: rgba(0, 0, 0, 0.2) !important;
                }
                .vs {
                  color: #fff !important;
                }
              }
              min-height: 188px;
              border-radius: 0px 0px 3px 3px;
              background: #ECF1F2;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-evenly;
              font-size: 20px;

              .team {
                display: flex;
                font-weight: 600;
                color: #4D4D4D;
                font-size: 18px;
                img {
                  width: 25px;
                  height: 25px;
                }
                .team-name {
                  position: relative;
                  .complete-img {
                    width: 18px;
                    height: 18px;
                    position: absolute;
                    right: -24px;
                    top: 3px;
                  }
                }

                .team-badge {
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
                  margin-right: 4px;
                }

                .name-remark {
                  font-size: 10px;
                }

                .delegation {
                  display: inline;
                  font-size: 12px;
                  color: #3F3F3F;
                  background: #D7F4F1;
                  padding: 2px 11px;
                  text-align: center;
                  margin-top: 4px;
                  border-radius: 4px;
                }
              }
            }
          }
        }
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }

    scrollbar-width: none;
    -ms-overflow-style: none;
  }
}

.vs {
  .sub-score {
    display: flex;
    gap: 4px;
    margin: 4px 0;
    justify-content: center;

    > div {
      width: 26px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #D8D8D8;
      border-radius: 2px;
      font-size: 15px;
      font-weight: 500;
      color: #8D8D8D;

      &.win {
        color: #4D4D4D;
        background: #C2E5E3;
      }
    }
  }
}
</style>

